import { useState, useRef, useEffect } from 'react'
import { useSelector } from 'react-redux'
import { useLocation, useNavigate } from 'react-router-dom'
import { selectUser } from '../../../../redux/slices/authSlice'
import { selectAuditEntries } from '../../../../redux/slices/auditSlice'
import { Bell, X } from 'react-feather'
import './Topbar.scss'

const TITLES = {
  '/dashboard':'Dashboard', '/rule-builder':'Rule Builder',
  '/orchestration':'Orchestration', '/transactions':'Transactions',
  '/alerts':'Alerts', '/reports':'Reports', '/merchants':'Merchants',
  '/audit-log':'Audit Log', '/settings':'Settings', '/profile':'Profile',
}

// Derive notifications from recent audit entries (ACCESS_DENIED, LOGIN, etc.)
const useNotifications = () => {
  const entries = useSelector(selectAuditEntries)
  return entries
    .filter(e => ['ACCESS_DENIED','LOGIN','SSO_LOGIN','RULE_DELETED'].includes(e.action))
    .slice(0, 5)
    .map(e => ({
      id:      e.id,
      title:   e.action.replace(/_/g,' '),
      sub:     e.meta?.path || e.meta?.email || '',
      time:    new Date(e.timestamp).toLocaleTimeString('en-IN',{ hour:'2-digit', minute:'2-digit' }),
      unread:  true,
    }))
}

const Topbar = () => {
  const user          = useSelector(selectUser)
  const location      = useLocation()
  const navigate      = useNavigate()
  const notifications = useNotifications()
  const [notifOpen, setNotifOpen] = useState(false)
  const notifRef      = useRef(null)

  // Close dropdown on outside click
  useEffect(() => {
    const handler = (e) => {
      if (notifRef.current && !notifRef.current.contains(e.target)) setNotifOpen(false)
    }
    document.addEventListener('mousedown', handler)
    return () => document.removeEventListener('mousedown', handler)
  }, [])

  return (
    <header className="topbar">
      <h2 className="topbar-title">{TITLES[location.pathname] || ''}</h2>

      <div className="topbar-right">

        {/* Notification bell */}
        <div className="notif-wrap" ref={notifRef}>
          <button
            className={`topbar-icon-btn ${notifOpen ? 'active' : ''}`}
            onClick={() => setNotifOpen(v => !v)}
            aria-label="Notifications"
          >
            <Bell size={15} />
            {notifications.length > 0 && <span className="notif-badge">{notifications.length}</span>}
          </button>

          {notifOpen && (
            <div className="notif-dropdown">
              <div className="notif-dropdown__header">
                <span>Notifications</span>
                <button className="notif-dropdown__close" onClick={() => setNotifOpen(false)}>
                  <X size={13} />
                </button>
              </div>
              {notifications.length === 0 ? (
                <div className="notif-empty">
                  <span className="notif-empty__icon">🔔</span>
                  <span>No notifications</span>
                </div>
              ) : (
                <ul className="notif-list">
                  {notifications.map(n => (
                    <li key={n.id} className="notif-item">
                      <div className="notif-item__dot" />
                      <div className="notif-item__body">
                        <span className="notif-item__title">{n.title}</span>
                        {n.sub && <span className="notif-item__sub">{n.sub}</span>}
                      </div>
                      <span className="notif-item__time">{n.time}</span>
                    </li>
                  ))}
                </ul>
              )}
            </div>
          )}
        </div>

        {/* User pill — clicks to profile */}
        {user && (
          <button className="topbar-user" onClick={() => navigate('/profile')} title="View profile">
            <div className="topbar-avatar">{(user.name || user.email || '?')[0].toUpperCase()}</div>
            <div className="topbar-user-info">
              <span className="topbar-user-name">{user.name || user.email}</span>
              <span className="topbar-user-role">{user.role}</span>
            </div>
          </button>
        )}
      </div>
    </header>
  )
}

export default Topbar